export var FIGURINES_WITH_STARS = false;
export var SAVE_STATE_FEATURE = FOR_VK;
export var USE_ROTATE = (FOR_YANDEX || FOR_CRAZY_GAMES) && !IS_ULTRA;
export var CANCEL_MOVES_FEATURE = false;
export var CANCEL_MOVE_FEATURE = (FOR_VK || FOR_YANDEX) && !IS_ULTRA;
export var BIN_FEATURE = FOR_VK || FOR_YANDEX;
export var DAILY_BONUS_FEATURE = FOR_VK;
